const SERVER_URL = 'https://node.thor.financial';

export async function fetTotalBalance() {
  return fetch(`${SERVER_URL}/debank/fetTotalBalance?id=0x8942904901b65a544549ed57b66a43187522afe3`).then((res) =>
    res.json(),
  );
}
